import { defineComponent } from "vue";
import { isAex } from "@/brand";

import { COMPONENT_NAME } from "./attributes";

import { AuthHeader, AuthIntroduction } from "@/components/layouts/auth";

export default defineComponent({
  name: COMPONENT_NAME,
  data: () => ({ isAex }),
  components: {
    AuthHeader,
    AuthIntroduction,
  },
});
